import * as mod from 'common-ui/lib/common/Layout/Layout';

export default mod.default;
